import { z } from 'src/lib'
import { EntityWithIdFields, schemaEntityWithId } from 'src/types'

export const ComentarioFields = {
    ...EntityWithIdFields,
    CodComentarioTipo: 'codComentarioTipo',
    Comentario: 'comentario',
    FechaAlta: 'fechaAlta',
    DescripcionUsuario: 'descUsuario',
    DescripcionComentarioTipo: 'descComentarioTipo'
} as const

export const schemaComentario = z
    .object({
        [ComentarioFields.CodComentarioTipo]: z.number(),
        [ComentarioFields.Comentario]: z.string(),
        [ComentarioFields.FechaAlta]: z.coerce.date(),
        [ComentarioFields.DescripcionUsuario]: z.string(),
        [ComentarioFields.DescripcionComentarioTipo]: z.string()
    })
    .merge(schemaEntityWithId)

export type Comentario = z.infer<typeof schemaComentario>

export const ComentarioPostFields = {
    CodComentarioTipo: 'codComentarioTipo',
    Comentario: 'comentario'
} as const
